import React from 'react';

import { connect } from 'react-redux';
import userActions from '../../redux/futures/user/actions';
import storeActions from '../../redux/futures/store/actions';
import _, { cloneDeep } from 'lodash';
import appConst from '../../config/const';
import Pagination from "react-js-pagination";
import baseHelper from '../../helpers/BaseHelper';
import * as userTypes from '../../redux/futures/user/types';
import * as partnerTypes from '../../redux/futures/partner/types';

import Form from './components/Form';
import GetPassword from './components/GetPassword';
import View from './components/View';
import ChangeCredit from './components/ChangeCredit';
import ChangePoint from './components/ChangePoint';
import ActivePartner from './components/ActivePartner';
import ActiveAiCall from './components/ActiveAiCall';
import DeleteAiCall from './components/DeleteAiCall';
import LoadingTable from '../../components/LoadingTable';

import "react-datepicker/dist/react-datepicker.css";
import ConfirmModal from '../../components/ConfirmModal';

class User extends React.Component {

    constructor(props) {
        super(props);
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.state = {
            activePage: 1,
            searchGlobalStatus: {
                name: appConst.USER_GLOBAL_STATUS.ALL.name,
                value: appConst.USER_GLOBAL_STATUS.ALL.value,
                selected: appConst.USER_GLOBAL_STATUS.ALL,
            },
            searchDemoStatus: {
                name: appConst.USER_DEMO_STATUS.NOT_USED.name,
                value: appConst.USER_DEMO_STATUS.NOT_USED.value,
                selected: appConst.USER_DEMO_STATUS.NOT_USED,
            },
            searchStatus: {
                name: appConst.USER_STATUS.ACTIVE.name,
                value: appConst.USER_STATUS.ACTIVE.value,
                selected: appConst.USER_STATUS.ACTIVE,
            },
            searchType: {
                name: appConst.USER_TYPE.ALL.name,
                value: appConst.USER_TYPE.ALL.value,
                selected: appConst.USER_TYPE.ALL,
            },
            searchDemo: false,
            fullname: "",
            id: "",
            email: "",
            phone: "",
            fromDate: firstDay,
            toDate: new Date(),
            selectedLimit: appConst.PAGINATION.LIMIT_OPTIONS[1].value,
            userList: [],
            copyiedStoreID: "",
            mode: appConst.FORM_MODE.CREATE,
            currentUser: {
                email: "",

                fullname: "",

                last_login: "",

                packages: "", // thông tin thanh toán

                phone: "",

                status: "",

                point: "",

                credit: "",

                created_at: "",

                _id: "",

                code: "",
                is_verify_email: false,
                is_verify_domain: false
            }
        }

        this.sortBy = {
            'store_id': 'ASC',
            'name': 'ASC',
            'created_at': 'ASC',
            'status': 'ASC',
        }
        this.selectedOrderIds = [];
        this.muteActions = [];
    }

    componentDidMount() {
        // this.list();
    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.user.action && !_.includes(this.muteActions, nextProps.user.action) && nextProps.user.action === userTypes.USER_LIST) {
            if (nextProps.user.status) {
                // window.LadiUI.toastr('success', '', nextProps.message);
            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }

        if (nextProps.partner.action == partnerTypes.CHANGE_CREDIT || nextProps.partner.action == partnerTypes.CREATE_PARTNER) {
            if (nextProps.partner.status) {
                const that = this;
                setTimeout(() => {
                    window.LadiUI.closeModalById('modal-user-addcredit');

                    that.list();
                }, 200);
            }
        }

        if (nextProps.user.action && nextProps.user.action === userTypes.HARD_DELETE_USER) {
            if (nextProps.user.status) {
                const that = this;
                window.LadiUI.toastr('success', '', nextProps.user.message);
                setTimeout(() => {
                    window.LadiUI.closeModalById('confirm-delete-user');

                    that.list();
                }, 200);

            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }

        if (nextProps.user.action && nextProps.user.action === userTypes.RESYNC_ADDON) {
            if (nextProps.user.status) {
                const that = this;
                this.selectedID = false;
                window.LadiUI.toastr('success', '', nextProps.user.message);
                setTimeout(() => {
                    window.LadiUI.closeModalById('confirm-resync-addon-user');

                    that.list();
                }, 200);

            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }

        if (nextProps.user.action && nextProps.user.action === userTypes.REMOVE_2FA) {
            if (nextProps.user.status) {
                const that = this;
                this.selectedID = false;
                window.LadiUI.toastr('success', '', nextProps.user.message);
                setTimeout(() => {
                    window.LadiUI.closeModalById('confirm-remove-2fa');

                    that.list();
                }, 200);

            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }

        if (nextProps.user.action && nextProps.user.action === userTypes.GET_FORGOTTEN_PASSWORD) {
            if (nextProps.user.status) {
                const url = nextProps.user.url;
                this.setState({
                    copyiedUserID: url
                }, () => {
                    this.textAreaRef.select();
                    document.execCommand('copy');
                    window.LadiUI.toastr('success', '', 'Đã copy vào clipboard');
                })

            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }

        if (nextProps.user.action && nextProps.user.action === userTypes.ADMIN_UPDATE_USER) {
            if (nextProps.user.status) {
                const that = this;
                window.LadiUI.toastr('success', '', nextProps.user.message);
                setTimeout(() => {
                    that.list();
                }, 200);

            } else {
                window.LadiUI.toastr('error', '', nextProps.user.message);
            }
        }
        if (nextProps.user.action && nextProps.user.action === userTypes.RESET_DEMO_ACCOUNT) {
            if (nextProps.user.status) {
                const that = this;
                window.LadiUI.toastr('success', '', nextProps.user.message);
                setTimeout(() => {
                    that.list();
                }, 200);
            }
        }

    }

    /**
     * list store
     */
    list = (resetActivePageFlag = true) => {
        const { selectedLimit, email, fullname, id, searchStatus, searchType, phone, searchDemo, searchDemoStatus, searchGlobalStatus } = this.state;
        let { activePage } = this.state;
        if (resetActivePageFlag) {
            activePage = 1;

            this.setState({
                activePage: 1,
            });
        }

        let { fromDate, toDate } = this.state;
        fromDate.setHours(0, 0, 0, 0);

        toDate.setHours(23, 59, 59, 999);

        const data = {
            "limit": selectedLimit,
            "offset": (activePage - 1) * selectedLimit,
            "from_date": fromDate,
            "to_date": toDate,
            "email": escape(email.trim()),
            phone: phone.trim(),
            "fullname": fullname.trim(),
            "id": id,
            "status": searchStatus.selected.value,
            "is_partner": searchType.selected.value,
            "is_demo": searchDemo,
            "is_global": searchGlobalStatus.selected.value
        };
        if (searchDemo) {
            if (searchDemoStatus.selected.value !== appConst.USER_DEMO_STATUS.ALL.value) {
                data.status = searchDemoStatus.selected.value;
            } else {
                delete data.status;
            }
        }
        // console.log(data);
        this.props.list(data);
    }

    /*******************************SEARCH***************************/
    onChangeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    /**
     * Tim kiem theo name
     */
    onKeyDownInput = (event) => {
        if (event.key === 'Enter') {

            this.list();
        }
    }

    /**
     * Tim kiem theo status
     */
    onChangeSearchStatus = (option) => {
        this.setState({
            searchStatus: { ...this.state.searchStatus, selected: option },
        }, () => {
            this.list();
        })
    }

    onChangeSearchDemoStatus = (option) => {
        this.setState({
            searchDemoStatus: { ...this.state.searchDemoStatus, selected: option },
        }, () => {
            this.list();
        })
    }

    onChangeSearchGlobalStatus = (option) => {
        this.setState({
            searchGlobalStatus: { ...this.state.searchGlobalStatus, selected: option },
        }, () => {
            this.list();
        })
    }

    onChangeSearchType = (option) => {
        this.setState({
            searchType: { ...this.state.searchType, selected: option },
        }, () => {
            this.list();
        })
    }

    onChangeSearchDemo = (event) => {
        this.setState({
            searchDemo: event.target.checked,
        }, () => {
            this.list();
        })
    }

    changeFromdate = (date) => {
        this.setState({
            fromDate: date
        }, () => {
            this.list();
        });

    }

    changeTodate = (date) => {
        this.setState({
            toDate: date
        }, () => {
            this.list();
        });

    }
    /****************************************************************/

    /*******************************PAGINATION***************************/
    /**
     * Change limit
     */
    onChangeLimit = (option) => {
        this.setState({ selectedLimit: option.value }, () => {
            this.list();
        })
    }

    /**
     * Change page
     */
    onPageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, () => {
            this.list(false);
        });
    }
    /****************************************************************/

    openCreateForm = () => {
        this.setState({
            currentUser: false,
            mode: appConst.FORM_MODE.CREATE
        })
    }

    openEditForm = (currentUser) => {
        this.setState({
            currentUser,
            mode: appConst.FORM_MODE.EDIT
        })
    }
    openGetPassword = (currentUser) => {
        this.setState({
            currentUser
        });

        if (currentUser._id) {
            // console.log({ladi_uid: currentUser._id});
            this.props.getToken({ ladi_uid: currentUser._id, email: currentUser.email });
        }
    }

    getForgottenpassword = (currentUser) => {
        this.setState({
            currentUser
        });

        if (currentUser._id) {
            // console.log({ladi_uid: currentUser._id});
            this.props.getForgottenPassword({ ladi_uid: currentUser._id, email: currentUser.email });
        }
    }
    /*******************************CHECK AND ACTIONS***************************/

    sort = (event) => {
        const { classList } = event.target;
        const name = event.target.getAttribute('name');
        // Change arrow up and down
        if (_.includes(classList, 'up')) {
            classList.remove('up');
            this.sortBy[name] = 'ASC';
        } else {
            classList.add('up');
            this.sortBy[name] = 'DESC';
        }

        this.setState({
        }, () => this.list());
    }

    view = (currentUser) => {
        this.setState({
            currentUser
        })
    }

    addPoint = (currentUser) => {
        this.setState({
            currentUser
        })
    }

    addCredit = (currentUser) => {
        this.setState({
            ldfUser: cloneDeep(currentUser)
        }, () => {

            const data = {
                app_code: 'LF'
            };
            this.props.listPackages(data);
            this.props.listDeals({ ladi_uid: currentUser._id });
        })
    }

    activePartner = (currentUser) => {
        this.setState({
            currentUser
        })
    }

    activeAiCall = (currentUser) => {
        this.setState({
            currentUser
        })
    }
    deleteAiCall = (currentUser) => {
        this.setState({
            currentUser
        })
    }

    remove2FA = (user) => {
        this.selectedID = user._id;
        window.LadiUI.showModalById('confirm-remove-2fa');
    }

    resyncAddon = (user) => {
        this.selectedID = user._id;
        window.LadiUI.showModalById('confirm-resync-addon-user');
    }

    resetAccountDemo = (user) => {
        this.selectedID = user._id;
        window.LadiUI.showModalById('confirm-clean-demo-account');
    }

    deleteUser = (selectedID) => {

        this.selectedID = selectedID;
        window.LadiUI.showModalById('confirm-delete-user');

    }

    copyToClipboard = (user) => {
        // console.log(store.store_id);
        this.setState({
            copyiedUserID: user._id
        }, () => {
            this.textAreaRef.select();
            document.execCommand('copy');
            window.LadiUI.toastr('success', '', 'Đã copy vào clipboard');
        })

    };
    /****************************************************************/


    render() {

        const { totalRecord } = this.props.user;
        const { activePage, selectedLimit, searchStatus, searchType, fullname, email, id, phone, currentUser, searchDemo, searchDemoStatus, searchGlobalStatus } = this.state;
        let fromItem = 0;
        let toItem = 0;
        if ((this.props.user.users || []).length > 0) {
            fromItem = (activePage - 1) * selectedLimit + 1;
            toItem = fromItem + this.props.user.users.length - 1;
        }

        const msgShowItem = `Show ${fromItem} to ${toItem} of ${baseHelper.formatNumber(totalRecord)} items`;
        const isLoadingData = this.props.user.loading && (this.props.user.waitting == userTypes.USER_LIST);
        const isLoadingPaid = this.props.user.loading && (this.props.user.waitting == userTypes.HARD_DELETE_USER);
        const isLoadingReset = this.props.user.loading && (this.props.user.waitting == userTypes.RESET_DEMO_ACCOUNT);
        const userInfo = baseHelper.getCookie(appConst.ADMIN_INFO);

        const partnerInfo = {
            email: "",

            credit: 0,

            _id: ""
        };
        if (currentUser._id) {
            partnerInfo.email = currentUser.email;
            partnerInfo.credit = currentUser.credit;
            partnerInfo._id = currentUser._id;
        }

        return (
            <div>
                <h1 className="page-title">Khách hàng</h1>

                <div>
                    <div className="ladiui-table-actions">
                        <div className="action-item">

                            <div className="ladiui search-keyword">
                                <input type="text" id="search" placeholder="Tìm theo email" name="email" value={email} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.list} />
                            </div>
                        </div>
                        <div className="action-item">

                            <div className="ladiui search-keyword" style={{ width: '170px' }}>
                                <input type="number" id="search" placeholder="Tìm theo số ĐT" name="phone" value={phone} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.list} />
                            </div>
                        </div>
                        {/* <div className="action-item">

                            <div className="ladiui search-keyword">
                                <input type="text" id="search" placeholder="Tìm theo tên" name="fullname" value={fullname} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.list} />
                            </div>
                        </div> */}
                        <div className="action-item">

                            <div className="ladiui search-keyword">
                                <input type="text" id="search" placeholder="Tìm theo UID" name="id" value={id} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.list} />
                            </div>
                        </div>
                        {!searchDemo &&
                            <div className="action-item">
                                <div className="ladiui data-status">
                                    <div className="ladiui-select-options" style={{ minWidth: '150px' }}>
                                        <span className="ladiui-select-init">{searchType.name}</span>
                                        <input type="hidden" name="select" defaultValue />
                                        <ul>
                                            {
                                                _.map(appConst.USER_TYPE, option =>
                                                    <li key={option.value} className="select-item" onClick={() => this.onChangeSearchType(option)}><a data-value={option.value}>{option.name}</a></li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {!searchDemo &&
                            <div className="action-item">
                                <div className="ladiui data-status">
                                    <div className="ladiui-select-options">
                                        <span className="ladiui-select-init">{searchStatus.name}</span>
                                        <input type="hidden" name="select" defaultValue />
                                        <ul>
                                            {
                                                _.map(appConst.USER_STATUS, option =>
                                                    <li key={option.value} className="select-item" onClick={() => this.onChangeSearchStatus(option)}><a data-value={option.value}>{option.name}</a></li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {searchDemo &&
                            <div className="action-item">
                                <div className="ladiui data-status">
                                    <div className="ladiui-select-options">
                                        <span className="ladiui-select-init">{searchDemoStatus.name}</span>
                                        <input type="hidden" name="select" defaultValue />
                                        <ul>
                                            {
                                                _.map(appConst.USER_DEMO_STATUS, option =>
                                                    <li key={option.value} className="select-item" onClick={() => this.onChangeSearchDemoStatus(option)}><a data-value={option.value}>{option.name}</a></li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="action-item">
                            <div className="ladiui data-status" style={{ width: '150px' }}>
                                <div className="ladiui-select-options">
                                    <span className="ladiui-select-init">{searchGlobalStatus.name}</span>
                                    <input type="hidden" name="select" defaultValue />
                                    <ul>
                                        {
                                            _.map(appConst.USER_GLOBAL_STATUS, option =>
                                                <li key={option.value} className="select-item" onClick={() => this.onChangeSearchGlobalStatus(option)}><a data-value={option.value}>{option.name}</a></li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="action-item">
                            <div className="ladiui data-status">
                                <label htmlFor="search-demo-checkbox" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', height: '40px', marginBottom: 0, cursor: 'pointer' }}>
                                    <input id="search-demo-checkbox" type="checkbox" onClick={(event) => this.onChangeSearchDemo(event)} className="ladiui checkbox" />
                                    <span>Lọc tài khoản demo</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    {
                        isLoadingData
                            ?
                            <LoadingTable />
                            :
                            <div>
                                <div className="ladi-card">

                                    <table className="ladiui table">
                                        <thead>
                                            <tr>

                                                {/* <th className="text-left">UID</th> */}
                                                <th className="text-left">Tên</th>
                                                <th className="text-left">Email</th>
                                                {searchDemo && (
                                                    <>
                                                        <th className="text-left">Clone from</th>
                                                        <th className="text-left">Password login</th>
                                                        <th className="text-left">Trạng thái đăng nhập</th>
                                                    </>
                                                )}
                                                <th className="text-left">Package</th>
                                                {!searchDemo && (
                                                    <>
                                                        <th className="text-left">Affiliate Code</th>
                                                        <th className="text-left">LadiFlow Ref</th>
                                                        <th className="text-left">Số điện thoại</th>
                                                    </>
                                                )}

                                                <th className="text-left">Credit</th>
                                                <th className="text-left">Điểm</th>
                                                <th className="text-left">Money</th>
                                                <th className="text-left">Partner Code</th>
                                                {!searchDemo &&
                                                    <th className="text-left">2FA Method</th>
                                                }
                                                {/* <th className="text-left">Đặng nhập gần nhất</th> */}
                                                {/* <th className="text-left">Trạng thái</th> */}
                                                {/* <th className="text-left">Commission Tier2</th> */}
                                                <th name="created_at" onClick={this.sort} className="text-left sorting">Thời gian đăng kí</th>
                                                {/* <th className="text-left">Affilate Email</th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                _.map(this.props.user.users, user => {
                                                    return <tr key={user._id}>
                                                        <td>{user.fullname.trim()}{user.is_demo && <span title="Demo account"> <i className={`ladiui icon icon-demo-account ${user.is_used ? 'used' : 'not-used'}`} style={{ cursor: "pointer", color: "#0C61F2", marginLeft: "10px", fontSize: "17px" }} /> </span>}{user.is_partner && <span title="Partner ship" style={{ position: 'absolute' }}> <i className="ladi-icon icon-d-check" style={{ cursor: "pointer", color: "#0C61F2", marginLeft: "10px", fontSize: "17px" }} /> </span>}{user.is_global && <span title="Global account" style={{ position: "absolute" }}><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1536 1896.0833" style={{ "width": "16px", "height": "16px", "fill": "blue" }}><path d="M768 128q209 0 385.5 103T1433 510.5 1536 896t-103 385.5-279.5 279.5T768 1664t-385.5-103T103 1281.5 0 896t103-385.5T382.5 231 768 128zm274 521q-2 1-9.5 9.5T1019 668q2 0 4.5-5t5-11 3.5-7q6-7 22-15 14-6 52-12 34-8 51 11-2-2 9.5-13t14.5-12q3-2 15-4.5t15-7.5l2-22q-12 1-17.5-7t-6.5-21q0 2-6 8 0-7-4.5-8t-11.5 1-9 1q-10-3-15-7.5t-8-16.5-4-15q-2-5-9.5-10.5T1112 484q-1-2-2.5-5.5t-3-6.5-4-5.5-5.5-2.5-7 5-7.5 10-4.5 5q-3-2-6-1.5t-4.5 1-4.5 3-5 3.5q-3 2-8.5 3t-8.5 2q15-5-1-11-10-4-16-3 9-4 7.5-12t-8.5-14h5q-1-4-8.5-8.5T1002 438t-13-6q-8-5-34-9.5t-33-.5q-5 6-4.5 10.5t4 14T925 459q1 6-5.5 13t-6.5 12q0 7 14 15.5t10 21.5q-3 8-16 16t-16 12q-5 8-1.5 18.5T914 584q2 2 1.5 4t-3.5 4.5-5.5 4-6.5 3.5l-3 2q-11 5-20.5-6T863 570q-7-25-16-30-23-8-29 1-5-13-41-26-25-9-58-4 6-1 0-15-7-15-19-12 3-6 4-17.5t1-13.5q3-13 12-23 1-1 7-8.5t9.5-13.5.5-6q35 4 50-11 5-5 11.5-17t10.5-17q9-6 14-5.5t14.5 5.5 14.5 5q14 1 15.5-11t-7.5-20q12 1 3-17-5-7-8-9-12-4-27 5-8 4 2 8-1-1-9.5 10.5T801 346t-16-5q-1-1-5.5-13.5T770 314q-8 0-16 15 3-8-11-15t-24-8q19-12-8-27-7-4-20.5-5t-19.5 4q-5 7-5.5 11.5t5 8T681 303t11.5 4 8.5 3q14 10 8 14-2 1-8.5 3.5T689 332t-6 4q-3 4 0 14t-2 14q-5-5-9-17.5t-7-16.5q7 9-25 6l-10-1q-4 0-16 2t-20.5 1-13.5-8q-4-8 0-20 1-4 4-2-4-3-11-9.5t-10-8.5q-46 15-94 41 6 1 12-1 5-2 13-6.5t10-5.5q34-14 42-7l5-5q14 16 20 25-7-4-30-1-20 6-22 12 7 12 5 18-4-3-11.5-10T498 339t-15-5q-16 0-22 1-146 80-235 222 7 7 12 8 4 1 5 9t2.5 11 11.5-3q9 8 3 19 1-1 44 27 19 17 21 21 3 11-10 18-1-2-9-9t-9-4q-3 5 .5 18.5T308 685q-7 0-9.5 16t-2.5 35.5-1 23.5l2 1q-3 12 5.5 34.5T324 815q-13 3 20 43 6 8 8 9 3 2 12 7.5t15 10 10 10.5q4 5 10 22.5t14 23.5q-2 6 9.5 20t10.5 23q-1 0-2.5 1t-2.5 1q3 7 15.5 14t15.5 13q1 3 2 10t3 11 8 2q2-20-24-62-15-25-17-29-3-5-5.5-15.5T421 915q2 0 6 1.5t8.5 3.5 7.5 4 2 3q-3 7 2 17.5t12 18.5 17 19 12 13q6 6 14 19.5t0 13.5q9 0 20 10t17 20q5 8 8 26t5 24q2 7 8.5 13.5t12.5 9.5l16 8 13 7q5 2 18.5 10.5T642 1168q10 4 16 4t14.5-2.5 13.5-3.5q15-2 29 15t21 21q36 19 55 11-2 1 .5 7.5t8 15.5 9 14.5 5.5 8.5q5 6 18 15t18 15q6-4 7-9-3 8 7 20t18 10q14-3 14-32-31 15-49-18 0-1-2.5-5.5t-4-8.5-2.5-8.5 0-7.5 5-3q9 0 10-3.5t-2-12.5-4-13q-1-8-11-20t-12-15q-5 9-16 8t-16-9q0 1-1.5 5.5t-1.5 6.5q-13 0-15-1 1-3 2.5-17.5t3.5-22.5q1-4 5.5-12t7.5-14.5 4-12.5-4.5-9.5-17.5-2.5q-19 1-26 20-1 3-3 10.5t-5 11.5-9 7q-7 3-24 2t-24-5q-13-8-22.5-29t-9.5-37q0-10 2.5-26.5t3-25T652 986q3-2 9-9.5t10-10.5q2-1 4.5-1.5t4.5 0 4-1.5 3-6q-1-1-4-3-3-3-4-3 7 3 28.5-1.5T735 951q15 11 22-2 0-1-2.5-9.5T754 926q5 27 29 9 3 3 15.5 5t17.5 5q3 2 7 5.5t5.5 4.5 5-.5 8.5-6.5q10 14 12 24 11 40 19 44 7 3 11 2t4.5-9.5 0-14T887 982l-1-8v-18l-1-8q-15-3-18.5-12t1.5-18.5 15-18.5q1-1 8-3.5t15.5-6.5 12.5-8q21-19 15-35 7 0 11-9-1 0-5-3t-7.5-5-4.5-2q9-5 2-16 5-3 7.5-11t7.5-10q9 12 21 2 7-8 1-16 5-7 20.5-10.5t18.5-9.5q7 2 8-2t1-12 3-12q4-5 15-9t13-5l17-11q3-4 0-4 18 2 31-11 10-11-6-20 3-6-3-9.5t-15-5.5q3-1 11.5-.5t10.5-1.5q15-10-7-16-17-5-43 12zm-163 877q206-36 351-189-3-3-12.5-4.5t-12.5-3.5q-18-7-24-8 1-7-2.5-13t-8-9-12.5-8-11-7q-2-2-7-6t-7-5.5-7.5-4.5-8.5-2-10 1l-3 1q-3 1-5.5 2.5t-5.5 3-4 3 0 2.5q-21-17-36-22-5-1-11-5.5t-10.5-7-10-1.5-11.5 7q-5 5-6 15t-2 13q-7-5 0-17.5t2-18.5q-3-6-10.5-4.5t-12 4.5-11.5 8.5-9 6.5-8.5 5.5-8.5 7.5q-3 4-6 12t-5 11q-2-4-11.5-6.5t-9.5-5.5q2 10 4 35t5 38q7 31-12 48-27 25-29 40-4 22 12 26 0 7-8 20.5t-7 21.5q0 6 2 16z"></path> </svg> </span>}</td>
                                                        <td>{user.email}</td>
                                                        {searchDemo &&
                                                            <>
                                                                <td>{user.source_email}</td>
                                                                <td>{user.user_data}</td>
                                                                <td>{(user.last_login !== null && user.last_login !== undefined) ? `Đã đăng nhập` : '--'}</td>
                                                            </>
                                                        }
                                                        <td>{user.pkg_name || '--'}</td>
                                                        {!searchDemo && (
                                                            <>
                                                                <td>{user.code}</td>
                                                                <td>{user.ladiflow_ref}</td>
                                                                <td>{user.phone} {user.is_verify_phone && <span > <i className="ladi-icon icon-d-check" style={{ cursor: "pointer", color: "#0C61F2", marginLeft: "10px", fontSize: "17px" }} /> </span>}</td>
                                                            </>
                                                        )}
                                                        <td>{user.credit != undefined ? baseHelper.numberWithCommas(user.credit.toFixed(2)) : `--`}</td>
                                                        <td>{user.credit_app != undefined ? baseHelper.numberWithCommas(user.credit_app.toFixed(2)) : `--`}</td>
                                                        <td>{user.money != undefined ? baseHelper.numberWithCommas(user.money) : `--`}</td>
                                                        <td >{user.partner_code != undefined ? user.partner_code : `--`}</td>
                                                        {!searchDemo &&
                                                            <td>{user.totp_enabled ? 'TOTP' : user.sms_2fa_enabled ? 'SMS' : '--'}</td>
                                                        }
                                                        <td>{baseHelper.formatStrToDate(user.created_at)}</td>
                                                        {/* <td>{user.affilate_id}</td> */}
                                                        <td>

                                                            <ul className="ladiui-navbar -horizontal row-actions">
                                                                <li className="ladiui-dropdown">
                                                                    <a><i className="ladi-icon icon-dots"></i></a>
                                                                    <ul>
                                                                        {
                                                                            (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.SUPPORT || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.resyncAddon(user)} >Đồng bộ lại addOn</a></li>
                                                                        }
                                                                        {
                                                                            (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.SUPPORT || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.openEditForm(user)} className="ladiui open-modal" modal="modal-unserinfoform" >Edit</a></li>
                                                                        }

                                                                        <li><a onClick={() => this.view(user)} className="ladiui open-modal" modal="modal-userview" >Chi tiết</a></li>
                                                                        {
                                                                            (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.SUPPORT ||
                                                                                userInfo.roleName == appConst.ROLE.AFFILATE_CARE || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.addCredit(user)} className="ladiui open-modal" modal="modal-user-addcredit" >Cộng credit</a></li>
                                                                        }
                                                                        {
                                                                            (!user.is_partner) && (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.AFFILATE_CARE || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.activePartner(user)} className="ladiui open-modal" modal="modal-user-active-partner" >Active Partner</a></li>
                                                                        }
                                                                        {
                                                                            (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.SUPPORT || userInfo.roleName == appConst.ROLE.SUPPORT_MANAGER || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.openGetPassword(user)} className="ladiui open-modal" modal="modal-temppassword" >Lấy mật khẩu</a></li>
                                                                        }
                                                                        <li><a onClick={() => this.copyToClipboard(user)} className="ladiui">Lấy ID</a></li>
                                                                        {
                                                                            (userInfo.roleName == appConst.ROLE.ADMIN || userInfo.roleName == appConst.ROLE.SUPPORT || userInfo.roleName == appConst.ROLE.SUPPORT_TOOL) &&
                                                                            <li><a onClick={() => this.addPoint(user)} className="ladiui open-modal" modal="modal-user-addpoint" >Cộng point</a></li>
                                                                        }
                                                                        <li><a onClick={() => this.remove2FA(user)} className="ladiui open-modal" modal="confirm-remove-2fa">Tắt 2FA</a></li>
                                                                        <li><a onClick={() => this.getForgottenpassword(user)} className="ladiui open-modal" modal="confirm-get-forgotten-password">Lấy link reset mật khẩu</a></li>
                                                                        <li><a onClick={() => this.activeAiCall(user)} className="ladiui open-modal" modal="modal-active-ai-call">Kích hoạt ai call</a></li>
                                                                        <li><a onClick={() => this.deleteAiCall(user)} className="ladiui open-modal" modal="modal-delete-ai-call">Xóa ai call</a></li>
                                                                        {
                                                                            user.is_demo &&
                                                                            <li><a onClick={() => this.resetAccountDemo(user)} >Reset tài khoản demo</a></li>
                                                                        }
                                                                    </ul>
                                                                </li>
                                                            </ul>

                                                        </td>
                                                    </tr>
                                                }
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    }
                    <div className="ladiui pagination-block">
                        <div className="ladiui search-actions">
                            <div className="ladiui form-filter">
                                <div className="ladiui data-limit">
                                    <span>Hiển thị</span>
                                    <div className="ladiui per-page">
                                        <div className="ladiui-select-options">
                                            <span className="ladiui-select-init">{selectedLimit}</span>
                                            <input type="hidden" name="select" defaultValue />
                                            <ul>
                                                {
                                                    _.map(appConst.PAGINATION.LIMIT_OPTIONS, option =>
                                                        <li key={option.value} className="select-item" onClick={() => this.onChangeLimit(option)}><a href="#" data-value={option.value}>{option.name}</a></li>
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="ladiui showing">{msgShowItem}</div>
                            </div>
                        </div>
                        {
                            totalRecord > 0 && <div className="ladiui pagination">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={selectedLimit}
                                    totalItemsCount={totalRecord}
                                    pageRangeDisplayed={5}
                                    onChange={this.onPageChange}
                                    prevPageText={<i className="ladi-icon icon-left-arrow" />}
                                    nextPageText={<i className="ladi-icon icon-right-arrow" />}
                                    firstPageText={<i className="ladi-icon icon-double-arrow-left" />}
                                    lastPageText={<i className="ladi-icon icon-double-arrow-right" />}
                                />
                            </div>
                        }

                    </div>
                </div>
                <View
                    currentUser={this.state.currentUser}
                />
                <ChangeCredit
                    currentUser={this.state.ldfUser}
                />
                <ActivePartner
                    currentUser={this.state.currentUser}
                />
                <GetPassword
                    currentUser={this.state.currentUser}
                />
                {/* <RenewPackages 
                     currentUser={this.state.currentUser} 
                 /> */}
                <ChangePoint currentUser={this.state.currentUser}
                />
                <Form
                    currentUser={this.state.currentUser}
                    mode={this.state.mode}
                />
                <ActiveAiCall
                    currentUser={this.state.currentUser}
                    activeAiCall={this.props.activeAiCall}
                    user={this.props.user}
                />
                <DeleteAiCall
                    currentUser={this.state.currentUser}
                    deleteAiCall={this.props.deleteAiCall}
                    user={this.props.user}
                />
                <ConfirmModal
                    id="confirm-resync-addon-user"
                    title="Đồng bộ lại addOn?"
                    content="Đồng bộ lại addOn Cho tài khoản này?"
                    cancelText="Hủy"
                    okText="Đồng bộ"
                    onOk={() => this.props.resyncAddon({
                        ladi_uid: this.selectedID,

                    })}
                    isLoading={isLoadingPaid}
                />
                <ConfirmModal
                    id="confirm-remove-2fa"
                    title="Remove 2FA?"
                    content="This action cannot be undone. Do you still want to continue?"
                    cancelText="Cancel"
                    okText="Remove"
                    onOk={() => this.props.remove2FA({
                        ladi_uid: this.selectedID,

                    })}
                    isLoading={isLoadingPaid}
                />
                <ConfirmModal
                    id="confirm-delete-user"
                    title="Delete user information?"
                    content="This action cannot be undone. Do you still want to continue?"
                    cancelText="Cancel"
                    okText="Delete"
                    onOk={() => this.props.deleteUser({
                        ladi_uid: this.selectedID,

                    })}
                    isLoading={isLoadingPaid}
                />
                <ConfirmModal
                    id="confirm-clean-demo-account"
                    title="Reset tài khoản demo?"
                    content="Reset tài khoản demo Cho tài khoản này và xóa hết dữ liệu trong store?"
                    cancelText="Hủy"
                    okText="Reset"
                    onOk={() => this.props.resetAccountDemo({
                        ladi_uid: this.selectedID,
                    })}
                    isLoading={isLoadingReset}
                />
                <input
                    readOnly
                    type="text"
                    className="ladiui input"
                    value={this.state.copyiedUserID}
                    ref={(textarea) => this.textAreaRef = textarea}
                    style={{
                        position: "absolute",
                        left: "-9999px"
                    }}
                />

            </div >
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        list: (data) => dispatch(userActions.list(data)),
        getToken: (data) => dispatch(userActions.getTempPassword(data)),
        deleteUser: (data) => dispatch(userActions.deleteUser(data)),
        listPackages: (data) => dispatch(storeActions.listPackages(data)),
        listDeals: (data) => dispatch(storeActions.listDeals(data)),
        resyncAddon: (data) => dispatch(userActions.resyncAddon(data)),
        remove2FA: (data) => dispatch(userActions.remove2FA(data)),
        getForgottenPassword: (data) => dispatch(userActions.getForgottenPassword(data)),
        activeAiCall: (data) => dispatch(userActions.activeAiCall(data)),
        deleteAiCall: (data) => dispatch(userActions.deleteAiCall(data)),
        resetAccountDemo: (data) => dispatch(userActions.resetAccountDemo(data)),
    }
}

const mapStateToProps = (state) => ({ user: { ...state.user }, partner: { ...state.partner } });

export default connect(mapStateToProps, mapDispatchToProps)(User);